import { Action } from '@ngrx/store';
import {
  EmployeeEquipmentWorkflowInterface,
  EmployeeEquipmentWorkflowStatusInterface,
  EquipmentCategoryInterface,
  EquipmentInterface } from 'app/equipment/models';

import { EquipmentActionType } from './equipment-action-type.enum';

export class CreateEquipmentCategory implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.CreateEquipmentCategory;

  constructor(public readonly payload: EquipmentCategoryInterface) { }
}

export class CreateEquipmentCategoryCompleted implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.CreateEquipmentCategoryCompleted;

  constructor(public readonly payload: EquipmentCategoryInterface) { }
}

export class CreateEquipmentCategoryFailed implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.CreateEquipmentCategoryFailed;

  constructor(public readonly payload: string) { }
}
export class CreateEquipmentLibraryItem implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.CreateEquipmentLibraryItem;

  constructor(public readonly payload: EquipmentInterface) { }
}

export class CreateEquipmentLibraryItemCompleted implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.CreateEquipmentLibraryItemCompleted;

  constructor(public readonly payload: EquipmentInterface) { }
}

export class CreateEquipmentLibraryItemFailed implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.CreateEquipmentLibraryItemFailed;

  constructor(public readonly payload: string) { }
}

export class CreateEmployeeEquipmentWorkflow implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.CreateEmployeeEquipmentWorkflow;

  constructor(public readonly payload: EmployeeEquipmentWorkflowInterface) { }
}

export class CreateEmployeeEquipmentWorkflowCompleted implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.CreateEmployeeEquipmentWorkflowCompleted;

  constructor(public readonly payload: EmployeeEquipmentWorkflowInterface) { }
}

export class CreateEmployeeEquipmentWorkflowFailed implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.CreateEmployeeEquipmentWorkflowFailed;

  constructor(public readonly payload: string) { }
}

export class AddNewStatusToEmployeeEquipmentWorkflow implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.AddNewStatusToEmployeeEquipmentWorkflow;

  constructor(public readonly payload:
    { workflow: EmployeeEquipmentWorkflowInterface, statusRecord: EmployeeEquipmentWorkflowStatusInterface }) { }
}

export class AddNewStatusToEmployeeEquipmentWorkflowCompleted implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.AddNewStatusToEmployeeEquipmentWorkflowCompleted;

  constructor(public readonly payload: EmployeeEquipmentWorkflowInterface) { }
}

export class AddNewStatusToEmployeeEquipmentWorkflowFailed implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.AddNewStatusToEmployeeEquipmentWorkflowFailed;

  constructor(public readonly payload: string) { }
}

